import React from 'react';
import { Link } from 'react-router-dom';
import { useIsPwaStandalone } from '../hooks/useIsPwaStandalone';

export interface LogoLinkProps {
  href?: string;
  className?: string;
  ariaLabel?: string;
  children: React.ReactNode;
}

/**
 * No web: logo é link para a landing (/home).
 * No PWA: logo não faz nada (só exibe, sem link).
 */
export function LogoLink({
  href = '/home',
  className = '',
  ariaLabel = 'RetornaAr - Página inicial',
  children,
}: LogoLinkProps) {
  const isPwa = useIsPwaStandalone();

  if (isPwa) {
    return (
      <div className={`cursor-default ${className}`.trim()} role="img" aria-label={ariaLabel}>
        {children}
      </div>
    );
  }

  return (
    <Link to={href} className={className} aria-label={ariaLabel}>
      {children}
    </Link>
  );
}
